import React from 'react';
import { ProviderFactory } from 'shared/providers/provider-factory';
import { useSessionStorage } from 'shared/hooks/use-session-storage';

const [Provider, useSidebarProvider] = ProviderFactory<{
  isSidebarOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}>('SidebarContext must be used within a SidebarProvider');

const SidebarProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  // FIXME this shouldn't be needed if we were using the proper routing structure
  const [isSidebarOpen, setValue] = useSessionStorage('sidebar-open', true);

  const handleOpen = React.useCallback(() => {
    setValue(true);
  }, [setValue]);

  const handleClose = React.useCallback(() => {
    setValue(false);
  }, [setValue]);

  return <Provider value={{ isSidebarOpen, handleOpen, handleClose }}>{children}</Provider>;
};

export { SidebarProvider, useSidebarProvider };
